import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import axios from 'axios';
// Actions
import {clearInvoice, getInvoice, getInvoiceHistory, getInvoiceVersions, getInvoiceVersionDetail, respondToInvoice} from "../../actions/invoices";
import {logout} from "../../actions/auth";
// components
import InvoiceWizard from "./InvoiceWizard";
import InvoiceDetailsCard from "./InvoiceDetailsCard";
import InvoiceHistoryModal from "./InvoiceHistoryModal";
import InvoiceVersionModal from "./InvoiceVersionModal";
import InvoiceStep2Review from "./invoiceSteps/InvoiceStep2Review";
import InvoiceStep3Pay from "./invoiceSteps/InvoiceStep3Pay";
import InvoiceStep3Rejected from "./invoiceSteps/InvoiceStep3Rejected";
import InvoiceStep4ConfirmReceived from "./invoiceSteps/InvoiceStep4ConfirmReceived";
import InvoiceActionRequired from "./InvoiceActionRequired";
import InvoiceModalToAdjudication from "./invoiceSteps/InvoiceModalToAdjudication";
import InvoiceModalToPushPC from "./invoiceSteps/InvoiceModalToPushPC";
import InvoiceStep4CloseAdjudication from "./invoiceSteps/InvoiceStep4CloseAdjudication";
import InvoiceStepPushPC from "./invoiceSteps/InvoiceStepPushPC";
// Helpers
import {daysBetween, orderArrayByDates, useSubmitGuard} from "../common/Helpers";



export function InvoiceView(props) {

    const [historyModalOpen, setHistoryModalOpen] = useState(false);
    const [versionModalOpen, setVersionModalOpen] = useState(false);
    const [selectedVersion, setSelectedVersion] = useState("");
    const [rejModalOpen, setRejModalOpen] = useState(false);
    const [pushPCModalOpen, setPushPCModalOpen] = useState(false);
    const [orderedHistory, setOrderedHistory] = useState([]);
    const [selectedFilesAdditional, setSelectedFilesAdditional] = useState([]);
    const {isSubmitting, guardedSubmit} = useSubmitGuard();

    const invoice = useSelector((state) => state.invoices.invoice);
    const auth = useSelector((state) => state.auth);
    const remaining_ = invoice.date_due ? daysBetween(invoice.send_date, invoice.date_due) : "NA";
    const remaining = invoice.date_due ? (remaining_.days === 0 ? `${remaining_.hours} hours` : `${remaining_.days} days`) : "NA"
    const versions = invoice.versions ? invoice.versions : [];

    useEffect(() => {
        // if an invoice submission is successful (causing invoice update), clear any attachments
        selectedFilesAdditional && setSelectedFilesAdditional([]);
    }, [invoice])

    useEffect(() => {
        // fetch the list of past (rejected-and-superseded) versions, if any, once the invoice loads
        invoice.invoice_id && props.getInvoiceVersions(invoice.invoice_id);
    }, [invoice.invoice_id])

    useEffect(() => {
        // whenever history modal opens, get most recent history
        historyModalOpen && props.getInvoiceHistory(invoice.invoice_id);
    }, [historyModalOpen])

    useEffect(() => {
        // whenever invoice updates other than the history modal opening/closing, close it
        historyModalOpen && setHistoryModalOpen(false);
    }, [invoice.stage, invoice.party_responsible])

    useEffect(() => {
        // whenever history reloads, reorder it by date
        if (invoice.history) {
            setOrderedHistory(orderArrayByDates(invoice.history, "event_date"))
        }
    }, [invoice.history])

    const handleShowVersion = () => {
        if (!selectedVersion) return;
        props.getInvoiceVersionDetail(selectedVersion);
        setVersionModalOpen(true);
    }


    const userIsResponsible = invoice.party_responsible ? (invoice.party_responsible.filter((party) => party.email === auth.user.email).length > 0) : false;

    // user has ability to skip to close invoice during review and payment required, if user is Accounts Receivable
    const userCanPushPC = (invoice.stage === "REV" || invoice.stage === "PR") && invoice.AR.email === auth.user.email;

    const downloadAttachment = (id, file_name) => {
        const fileDownload = require("js-file-download");
        axios.get(`/v0/api/core/download/${id}/`, {
            responseType: "blob",
            headers: { "Authorization": `Token ${auth.token}` }
        }).then(res => {
            fileDownload(res.data, file_name);
            //console.log(res);
        }).catch(err => {
            console.log(err);
        })
    }

/* NEW FORM FUNCTIONALITY START ------------------------------------------------------------------------------*/
/* -----------------------------------------------------------------------------------------------------------*/


const handleDrop = (files) => { 
    files.map(file => {
        let file_exists = undefined;
        file_exists = selectedFilesAdditional.find( ({ path }) => path === file.path );
        if (file_exists == undefined) {
            setSelectedFilesAdditional(
                selectedFilesAdditional => [...selectedFilesAdditional, file]
            )
        }
    });
}

const removeSelectedFile = (file_path) => { 
    setSelectedFilesAdditional(selectedFilesAdditional.filter((file) => file.path !== file_path));
}
    
const populateFormAttachments = (formData, updates) => {
    // take in the form object
    // loop through all updates (adding each one to the form object)
    for (var key in updates) {
        formData.append(key, updates[key]);
    }
    // loop through the attachments (adding each one to the form object)
    let file_counter = 1
    selectedFilesAdditional.map(file => {
        formData.append("additional-" + file_counter.toString(), file);
        file_counter++;
    });
    // return the final form object, containing updates & attachments
    return formData
}

const handleResponseSubmit = guardedSubmit((updates, message) => {
    // prevent automatic html form submission
    // instantiate form object
    let formData = new FormData();
    // bundle the updates and all selected attachments onto the form object
    formData = populateFormAttachments(formData, updates);
    return props.respondToInvoice(invoice.invoice_id, formData, message);
});

/* -----------------------------------------------------------------------------------------------------------*/
/* NEW FORM FUNCTIONALITY END --------------------------------------------------------------------------------*/


    const invoiceShow = (
        <div className="invoice-card">
            {rejModalOpen &&
                <InvoiceModalToAdjudication setRejModalOpen={setRejModalOpen} removeSelectedFile={removeSelectedFile} handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} selectedFilesAdditional={selectedFilesAdditional} handleDrop={handleDrop} />
            }
            {pushPCModalOpen &&
                <InvoiceModalToPushPC setPushPCModalOpen={setPushPCModalOpen} removeSelectedFile={removeSelectedFile} handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} selectedFilesAdditional={selectedFilesAdditional} handleDrop={handleDrop} />
            }
            {historyModalOpen &&
                <InvoiceHistoryModal setHistoryModalOpen={setHistoryModalOpen} orderedHistory={orderedHistory} />
            }
            {versionModalOpen &&
                <InvoiceVersionModal setVersionModalOpen={setVersionModalOpen} />
            }
            <div className="single-header">
                <div>
                    {/* <IconInvoices className="icon gap-right-xs" height="20px" pathClass="w-fill" /> */}
                    <h1 className="title heavy iblock">
                        Invoice
                        <span className="light g3-text">
                            {invoice.invoice_number ? `\u00A0 ${invoice.invoice_number}` + (invoice.version > 1 ? ` Version ${invoice.version}` : "") : "\u00A0 No Number"}
                        </span>
                    </h1>
                    {/* <h2 className="title2 heavy">{invoice.payment_due_date && formatDateTimeToZone(invoice.payment_due_date)}</h2>
                    <h2 className="title2 heavy">{invoice.payment_due_date && formatDateTimeToZone(invoice.payment_due_date, "Europe/London")}</h2> */}
                </div>
            </div>
            <div className="invoice-container">
                <div className="doc-section gap-below-m">
                    <h3 className="title2 heavy label">Action Required</h3>
                    <InvoiceActionRequired />
                    {userIsResponsible &&
                        <div className="gap-above-s gap-below-m">
                            {invoice.stage === "REV" && <InvoiceStep2Review removeSelectedFile={removeSelectedFile} handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} selectedFilesAdditional={selectedFilesAdditional} handleDrop={handleDrop} />}
                            {invoice.stage === "PR" && <InvoiceStep3Pay removeSelectedFile={removeSelectedFile} handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} selectedFilesAdditional={selectedFilesAdditional} handleDrop={handleDrop} />}
                            {invoice.stage === "PU" && <InvoiceStep4ConfirmReceived removeSelectedFile={removeSelectedFile} handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} selectedFilesAdditional={selectedFilesAdditional} handleDrop={handleDrop} />}
                            {invoice.stage === "REJ" && <InvoiceStep3Rejected handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} handleReroute={props.handleReroute} setRejModalOpen={setRejModalOpen} />}
                            {invoice.stage === "AI" && <InvoiceStep4CloseAdjudication removeSelectedFile={removeSelectedFile} handleResponseSubmit={handleResponseSubmit} isSubmitting={isSubmitting} selectedFilesAdditional={selectedFilesAdditional} handleDrop={handleDrop} />}
                        </div>}
                        {userCanPushPC && <InvoiceStepPushPC setPushPCModalOpen={setPushPCModalOpen} />}
                </div>
                <div className="doc-section gap-below-m">
                    <h3 className="title2 heavy label">Schedule</h3>
                    <InvoiceWizard className="gap-below-s" />
                    {/* <StageLandscape stage={invoice.stage}  className="gap-below-s"/> */}
                </div>
                <InvoiceDetailsCard
                    invoice={invoice}
                    downloadAttachment={downloadAttachment}
                    historyVersionsControls={
                        <div>
                            <h3 className="content2 heavy-grey iblock gap-right-s">History</h3>
                            <button className="btn sec mini iblock gap-right-l" onClick={() => setHistoryModalOpen(true)} >Show</button>
                            {versions.length > 0 &&
                            <>
                                <h3 className="content2 heavy-grey iblock gap-right-s">Versions</h3>
                                <div className="input-basic mini iblock">
                                    <select
                                        value={selectedVersion}
                                        onChange={(e) => setSelectedVersion(e.target.value)}
                                        style={selectedVersion ? { color: "#3C3B41" } : { color: "#919197" }}
                                    >
                                        <option value="">Select a version</option>
                                        {versions.map((v) => (
                                            <option key={v.invoice_id} value={v.invoice_id}>Version {v.version}</option>
                                        ))}
                                    </select>
                                </div>
                                <button className="btn sec mini iblock" disabled={!selectedVersion} onClick={handleShowVersion} >Show</button>
                            </>}
                        </div>
                    }
                />
            </div>
        </div>
    )

    return (
        <div className={auth ? "" : "flex-column center"}>
            {invoice.invoice_id ? invoiceShow : <></>}
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, { logout, clearInvoice, getInvoice, getInvoiceHistory, getInvoiceVersions, getInvoiceVersionDetail, respondToInvoice })(InvoiceView);